import { Component, EventEmitter, Input, OnChanges, OnInit, Output, Self, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { ApiServiceBase } from 'src/app/Services/api.service.base';

@Component({
    selector: 'app-sign-selector',
    templateUrl: './sign-selector.component.html',
    styleUrls: ['./sign-selector.component.scss'],
    standalone: false
})
export class SignSelectorComponent implements OnInit, ControlValueAccessor, OnChanges {
  public signChipId: string | null = null;
  @Output()
  public signIdChange = new EventEmitter<string | null>();

  public InitChipId = "";
  @Input()
  public Sign: any = {};

  public searchResults: any[] = [];
  public searchTerm: string = "ChipId";
  public isLoading = false;

  constructor(private apiService: ApiServiceBase, @Self() public ngControl: NgControl) {
    if (ngControl) {
      ngControl.valueAccessor = this;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.signChipId = this.Sign.ChipId;
    this.onChange(this.Sign.ChipId);
    this.signIdChange.emit(this.Sign);
  }

  public writeValue(id: string | null): void {
    console.log("Write value");

    this.signChipId = id;
    this.Sign.ChipId = id;
    if (this.signChipId == "") this.Sign = null;
  }
  public onChange = (id: string | null) => {
    this.signIdChange.emit(id);
   };
   
  public registerOnChange(fn: any): void {
    console.log("Reg on change");

    this.onChange = fn;
  }
  public onTouched = () => { };
  public registerOnTouched(fn: any): void {
    console.log("On Touched");

    this.onTouched = fn;
  }
  ngOnInit(): void {
  }


  public ItemSelected(item: any) {
    if (item && item != null && item.Id) {
      this.Sign = { Id: item.Id, ChipId: item.ChipId, OrganizationId: item.OrganizationId };
      this.signChipId = item.ChipId;
      this.onChange(item.ChipId);
      this.signIdChange.emit(this.Sign);
    }
  }
  public SearchChanged(val: string) {
    console.log("Sensor Selector search event: '" + val + "'");
    if (val == null || val == "") return;
    this.Sign = null;
    this.isLoading = true;
    //"infrastructure/sensor/searches"
    this.apiService.Post<any>("hardware/signs/searches", { PageNumber: 1, PageSize: 8, SearchTerm: val }).then(result => {
      this.searchResults = [];
      result.Results.forEach((element: any) => {
        this.searchResults.push({
          ChipId: element.ChipId.toString(),
          Id: element.Id,
          OrganizationId: element.OrganizationId
        });
      });

      console.log("Search results: ");

      console.log(this.searchResults);

      this.isLoading = false;
    });
  }
  public ClearSign() {
    this.signChipId = null;
    this.onChange(null);
  }

  public Cleared() {
    this.signChipId = null;
    this.onChange(null);
  }
  public KeyPress(evt: any) {
    if (evt.keyCode == 13) {
      evt.stopPropagation();
    }
  }
  public InputKeyPress(evt: any) {

  }
}
